import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators, ValidatorFn, AbstractControl, AsyncValidatorFn } from '@angular/forms';

import { QuestionBase } from '../model/question-base';
import { AngularFirestore } from '@angular/fire/firestore';
import { debounceTime, map, take, tap } from 'rxjs/operators';

@Injectable()
export class QuestionControlService {
  constructor(private afs: AngularFirestore) { }

  toFormGroup(questions: QuestionBase<any>[] ) {
    const group: any = {};
    console.log('questionsFormGroup',questions)
    
    questions.forEach(question => {
      if(question.validators?.length && !question.asyncValidators?.length){
        group[question.key] = new FormControl(question.value ?? '', this.getValidators(question.validators))
        
      }else if (question.validators?.length && question.asyncValidators?.length){

        group[question.key] =  new FormControl(question.value ?? '', this.getValidators(question.validators),this.getAsyncValidators(question.asyncValidators,question.value))
      } else {
        group[question.key] =  new FormControl(question.value ?? '');
      }

    });
    console.log('questionsFormGroup',questions,group)
    return new FormGroup(group);
  }


  getValidators (validators:any){
  const validatorsArray: ValidatorFn[]= []
  for (let i in validators) {

    switch(validators[i].key) { 
      case 'required': { 
         const val = Validators.required
         validatorsArray.push(val)
         break; 
      } 
      case 'max': { 
        const val = Validators.max(validators[i].value)
        validatorsArray.push(val)
         break; 
      } 
      case 'min': { 
        const val = Validators.min(validators[i].value)
        validatorsArray.push(val)
         break; 
      } 
      case 'maxLength': { 
        const val = Validators.maxLength(validators[i].value)
        validatorsArray.push(val)
         break; 
      } 
      case 'minLength': { 
        const val = Validators.minLength(validators[i].value)
        validatorsArray.push(val)
         break; 
      } 
      case 'pattern': { 
        const val = Validators.pattern(validators[i].value)
        validatorsArray.push(val)
         break; 
      } 
      case 'email': { 
        const val = Validators.email
        validatorsArray.push(val)
         break; 
      } 
      case 'requiredTrue': { 
        const val = Validators.requiredTrue
        validatorsArray.push(val)
         break; 
      } 
   } 
 }
return validatorsArray
  }

  getAsyncValidators(asyncValidators:any, currentValue?){
    const validatorsArray: AsyncValidatorFn[]= []
    for (let i in asyncValidators) {
  
      switch(asyncValidators[i].key) { 
        case 'uniqueKey': { 
           const val = CustomValidator.uniqueKey(this.afs, asyncValidators[i].value.route,asyncValidators[i].value.key,currentValue)
           validatorsArray.push(val)
           break; 
        } 
        
     } 
   }
  return validatorsArray
  }


}


export class CustomValidator{
  static uniqueKey(afs:AngularFirestore,route:string,key:string,currentValue?:string){
    return(control:AbstractControl) =>{
        const value = control.value.toLowerCase();
        console.log('route:string,key:string,',route,key)
       
        return currentValue ? afs.collection(route, ref=> ref.where(key,'==', value))
        .valueChanges().pipe(
          debounceTime(500),
          take(1),
          map( results => results.filter((r:any) => r[key] !== currentValue)),
          // tap(x=>console.log('customvalidatorresp currentvalue', x)),
          map(arr=>arr.length ? {uniqueKey:true}: null)
        ) 
        : afs.collection(route, ref=> ref.where(key,'==', value))
        .valueChanges().pipe(
          debounceTime(500),
          take(1),
          // tap(x=>console.log('customvalidatorresp', x)),
          map(arr=>arr.length ? {uniqueKey:true}: null)
        ) 
    }
  }
}